import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import { paymentScheme } from "../scheme/paymentScheme";
import { yupResolver } from "@hookform/resolvers/yup";

import { FormGroup, Grid, RadioGroup, Typography, Button } from "@mui/material";

import CheckboxControlled from "components/Controllers/Checkbox";

import CardForm from "./CardForm";
import PSEForm from "./PSEForm";
import PurchaseSummary from "./PurchaseSummary";

import {
  TERMS_OF_DEBITS,
  TERMS_OF_USE,
} from "components/constants/payment-link";

import {
  createPaymentLink,
  formalizeAdvancePayment,
  formalizePayment,
  generateElectronicInvoice,
} from "services/paymentLink";
import SharedModal from "components/shared/SharedModal";
import { pagesUrl } from "utils/misc";

const Form = (props) => {
  const { information } = props;

  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [messageHeader, setMessageHeader] = useState("");
  const [messageBody, setMessageBody] = useState("");
  const [hideModalButton, setHideModalButton] = useState(false);
  const [reloadWindow, setReloadWindow] = useState(false);

  const {
    handleSubmit,
    watch,
    control,
    reset,
    formState: { isValid },
  } = useForm({
    defaultValues: { payment_type: "card" },
    resolver: yupResolver(paymentScheme),
    mode: "onChange",
  });

  const sendInvoice = async (id_invoice) => {
    const { data } = await generateElectronicInvoice({ id_invoice });
  };

  const formalize = async (payload) => {
    // let response_aldp;
    // response_aldp = await formalizeAdvancePayment(payload?.uuid);
    // setMessageBody(message);
    // return;
    // sendInvoice(response_aldp?.data?.data?.invoice?.id);
    // response = await formalizePayment(payload?.metadata);
    // if (response?.data?.data?.invoice?.id) {
    //   setMessageBody("Tu pago ha sido formalizado correctamente!");
    //   sendInvoice(response?.data?.data?.invoice?.id);
    //   return;
    // }
    // setMessageBody(
    //   "Se produjo un error formalizando tu pago, puedes consultar usando la referencia " +
    //   payload?.payment_link?.uuid
    // );
    // return;
  };

  const onSubmit = (data) => {
    setLoading(true);

    data.uuid = information.uuid;
    data.subtotal = information.subtotal;
    data.discount = information.discounts;
    data.total = information.total;

    createPaymentLink(data)
      .then((resp) => {
        if (resp.data.status === "success" && resp.data.data.pse_link) {
          setMessageHeader("Redireccionando a PSE...");
          setMessageBody(
            "Por favor espera un momento mientras te dirigimos a la plataforma de pagos PSE."
          );
          setHideModalButton(true);
          setOpenModal(true);
          window.location.replace(resp.data.data.pse_link);
          return;
        }

        if (
          resp.data.status === "success" &&
          resp.data.data?.harvest_response?.payment_status === "Aprobada"
        ) {
          const payload = resp.data.data;
          const message = payload?.payment_link?.proposals_id
            ? "Bienvenido. Esperamos que disfrutes de todos los beneficios. Si necesitas ayuda, estamos aquí para asistirte."
            : "Gracias por seguir con nosotros, tu suscripción está activa. Si tienes preguntas, nuestro equipo de soporte está listo para ayudarte.";
          setMessageHeader("¡Tu pago ha sido recibido!");
          setMessageBody(message);
          setOpenModal(true);
          setReloadWindow(true);

          return;
        }

        if (
          resp.data.status === "success" &&
          resp.data.data?.payment_status === "rechazada"
        ) {
          setMessageHeader("Transaccion rechazada!");
          setMessageBody(
            "Por favor verifica los datos de la tarjeta o intenta usando otro medio de pago!"
          );
          setOpenModal(true);
          return;
        }

        if (resp.data.status === "error") {
          setMessageHeader("Se produjo un error");
          setMessageBody(
            resp?.data?.message?.length
              ? resp?.data?.message[0]?.message
              : "Intenta nuevamente"
          );
          setOpenModal(true);
          return;
        }
      })
      .catch((error) => console.error("Fetch error: 😱", error))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    reset({
      payment_type: watch("payment_type") === "card" ? "card" : "pse",
    });
  }, [watch("payment_type")]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2} p={3}>
          <Grid
            item
            xs={12}
            container
            justifyContent={{ xs: "center", md: "flex-start" }}
          >
            <Typography variant="title" color="primary">
              MÉTODO DE PAGO
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography>
              Todas las transacciones se realizan de forma segura
            </Typography>
            <Typography maxWidth={{ md: "60%", xs: "100%" }} fontWeight="bold">
              Los pagos se procesan individualmente. Si deseas pagar más de una
              cuota, deberás hacerlo de forma separada, siguiendo el mismo
              procedimiento para cada una.
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <RadioGroup
              row
              sx={{
                display: "flex",
                justifyContent: { xs: "center", md: "flex-start" },
              }}
              value={watch("payment_type")}
            >
              <CheckboxControlled
                type="radio"
                name="payment_type"
                control={control}
                value="card"
                label="CRÉDITO / DÉBITO"
              />
              {props.currentBrand !== "3" && (
                <CheckboxControlled
                  type="radio"
                  name="payment_type"
                  control={control}
                  value="pse"
                  label="PSE"
                />
              )}
            </RadioGroup>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={4}>
              <Grid item xs={12} md={8}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    {watch("payment_type") === "card" ? (
                      <CardForm
                        docTypes={props?.docTypes}
                        control={control}
                        watch={watch}
                      />
                    ) : (
                      <PSEForm control={control} />
                    )}
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={watch("payment_type") === "card" ? 6 : 12}
                  >
                    <FormGroup>
                      <CheckboxControlled
                        name="terms_of_use"
                        control={control}
                        label={
                          <Typography
                            variant="caption"
                            sx={{ fontSize: 12, textAlign: "justify" }}
                          >
                            {TERMS_OF_USE}
                          </Typography>
                        }
                      />
                      {/* <CheckboxControlled name="terms_of_debits" control={control} label={<Typography variant="caption" sx={{ fontSize: 12, textAlign: 'justify' }}>{TERMS_OF_DEBITS}</Typography>} /> */}
                    </FormGroup>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={4}>
                <PurchaseSummary
                  information={information}
                  isValid={isValid}
                  loading={loading}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>

      <SharedModal
        isOpen={openModal}
        modalBody={
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography
                variant="title"
                color="primary"
                display="block"
                align="center"
              >
                {messageHeader}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography align="center">{messageBody}</Typography>
            </Grid>

            {!hideModalButton && (
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={
                    reloadWindow
                      ? () => window.location.reload()
                      : () => setOpenModal(false)
                  }
                >
                  {"Ver detalle"}
                </Button>
              </Grid>
            )}
          </Grid>
        }
      />
    </>
  );
};

export default Form;
